export enum UtilProspecto {
    VALOR_DEFECTO,
    PRIMER_USO,
    MULTIPLE_USO
}